export const COPY = {
  fr: {
    header: {
      nav: {
        solutions: "Solutions",
        highlights: "Avantages",
        resources: "Ressources",
        success: "Success Stories",
        invest: "Investir au Bénin",
        donate: "Faire un don",
        contact: "Contact",
      },
      whatsapp: "WhatsApp",
    },
    meta: {
      title: "Nexus Benin SAS | Pompes solaires & irrigation au Bénin",
      description:
        "Pompes solaires, irrigation goutte-à-goutte, accès à l’eau et projets solaires au Bénin. Distributeur officiel ENNOS Sunlight Pumps.",
      ogTitle: "Nexus Benin SAS | Pompes solaires & irrigation au Bénin",
      ogDescription:
        "Pompes solaires, irrigation goutte-à-goutte, accès à l’eau et projets solaires au Bénin. Distributeur officiel ENNOS Sunlight Pumps.",
      ogLocale: "fr_FR",
    },
    hero: {
      kicker: "Révolutionner l’accès à l’eau au Bénin grâce à l’énergie solaire",
      title: "Pompage solaire et irrigation intelligente pour le Bénin",
      subtitle:
        "Réduisez les coûts de carburant, sécurisez l’accès à l’eau et développez vos cultures avec des solutions solaires prêtes à l’emploi.",
      primaryCta: "Demander un devis",
      secondaryCta: "Voir les solutions",
      whatsappPrefill:
        "Bonjour Nexus Benin, je souhaite demander un devis pour un projet d'irrigation.",
      trustBadges: [
        "Distributeur Ennos au Bénin",
        "Installation locale",
        "Solutions pour agriculture & eau",
        "Financement possible",
      ],
      imageAlt: "Pompe solaire Ennos SLP 0,5 HP",
    },
    problem: {
      kicker: "Problème / Opportunité",
      title: "L’eau est le premier levier de productivité agricole",
      body:
        "Au Bénin, la saison sèche, le coût du carburant et l’irrégularité des pompes thermiques freinent la croissance agricole. Nexus Benin SAS propose une alternative solaire propre, prévisible et à faible maintenance pour sécuriser l’accès à l’eau toute l’année.",
      impactTitle: "Impact immédiat",
      impactItems: [
        "Moins de dépenses en carburant",
        "Autonomie énergétique totale",
        "Productivité agricole renforcée",
      ],
      ctaPrimary: "Découvrir nos solutions solaires",
      ctaSecondary: "Voir le projet eau propre",
    },
    solutions: {
      kicker: "Solutions",
      title: "Des solutions solaires adaptées aux réalités agricoles du Bénin",
      items: [
        {
          title: "Pompes solaires Ennos",
          description: "Pompage sans carburant, installation mobile, fonctionnement solaire direct.",
        },
        {
          title: "Irrigation goutte-à-goutte",
          description:
            "Distribution efficace de l’eau pour cultures maraîchères, agroforesterie et projets agricoles.",
        },
        {
          title: "Kits agricoles clés en main",
          description: "Pompe, panneaux PV, tuyaux, câbles et accessoires adaptés au terrain.",
        },
        {
          title: "Déploiement & support local",
          description: "Conseil, importation, mise en service, formation et suivi au Bénin.",
        },
      ],
      cta: "Demander un devis",
    },
    highlights: {
      kicker: "Product Highlights",
      title: "Des performances solides pour l’irrigation et l’accès à l’eau",
      items: [
        "Fonctionnement sans carburant",
        "Installation facile & mobile",
        "Compatible irrigation",
        "Réduction des coûts d’exploitation",
        "Maintenance limitée",
        "Longue durée de vie",
        "Jusqu’à 210 000 litres/jour selon le modèle",
        "Irrigation de petites parcelles jusqu’à 10+ hectares selon le projet",
      ],
      note:
        "Les performances dépendent du modèle, de la hauteur manométrique, de l’ensoleillement et de la configuration du site.",
      button: "Voir le catalogue Ennos 2025",
      imageAlt: "Kit irrigation goutte-à-goutte",
    },
    resources: {
      kicker: "Ressources",
      title: "Téléchargez nos brochures techniques",
      subtitle:
        "Fiches techniques, guides d’installation et documents ENNOS pour préparer votre projet.",
      formatLabel: "PDF",
      items: [
        {
          id: "catalog-2025",
          title: "Catalogue ENNOS 2025",
          description:
            "Toutes les gammes de pompes solaires ENNOS et accessoires disponibles.",
          cta: "Télécharger le catalogue",
        },
        {
          id: "datasheet-05hp",
          title: "Fiche technique Sunlight Pump 0,5 HP",
          description:
            "Caractéristiques, débits et courbes de performance pour la pompe SLP 0,5 HP.",
          cta: "Télécharger la fiche",
        },
        {
          id: "manual-2020",
          title: "Manuel opérationnel Sunlight Pump 2020",
          description: "Procédures d’utilisation, entretien et consignes de sécurité.",
          cta: "Télécharger le manuel",
        },
        {
          id: "install-guide-05hp",
          title: "Guide d’installation Sunlight Pump 0,5 HP",
          description: "Étapes d’installation terrain pour une mise en service rapide.",
          cta: "Télécharger le guide",
        },
        {
          id: "dos-and-donts",
          title: "Consignes ENNOS (Dos & Don'ts)",
          description:
            "Bonnes pratiques d’utilisation et précautions essentielles à suivre.",
          cta: "Télécharger les consignes",
        },
        {
          id: "app-guide",
          title: "Guide application ENNOS",
          description: "Configuration et utilisation de l’application de suivi ENNOS.",
          cta: "Télécharger le guide",
        },
        {
          id: "ennos-brochure-fr",
          title: "Brochure ENNOS (FR)",
          description: "Présentation des solutions ENNOS et bénéfices clés.",
          cta: "Télécharger la brochure",
        },
        {
          id: "sunlight-pump-use-cases",
          title: "Cas d’usage Sunlight Pump",
          description: "Exemples d’applications terrain et résultats obtenus.",
          cta: "Télécharger les cas d’usage",
        },
        {
          id: "drip-kit-manual",
          title: "Manuel kit goutte-à-goutte",
          description: "Guide d’installation et d’utilisation du kit d’irrigation.",
          cta: "Télécharger le manuel",
        },
      ],
    },
    why: {
      kicker: "Pourquoi Nexus Benin",
      title: "Un partenaire local pour transformer le solaire en impact",
      partnerPoints: [
        "Présence locale à Grand-Popo / Bénin",
        "Expertise sourcing, importation et déploiement",
        "Solutions adaptées aux agriculteurs, ONG, investisseurs et institutions",
        "Support local réactif",
        "Partenariats internationaux et distribution de technologies solaires fiables",
      ],
      roles: {
        hortense: "Présidente, Nexus Benin SAS",
        martin: "Directeur Opérationnel",
      },
      cardAlt: {
        hortense: "Carte Nexus Benin",
        martin: "Carte Martin Ehlers",
      },
    },
    ennosVideo: {
      kicker: "ENNOS en vidéo",
      title: "Découvrez les pompes ENNOS Sunlight en action",
      subtitle: "Technologie solaire éprouvée et démonstrations réelles",
      body:
        "Regardez les pompes ENNOS fonctionner sur le terrain. Nexus Benin vous accompagne localement pour des projets agricoles, ONG et accès à l’eau.",
      cta: "Voir ENNOS sur YouTube",
      microcopy: "Démonstrations officielles ENNOS — soutien local Nexus Benin.",
      playLabel: "Regarder la vidéo",
      thumbnailAlt: "Démonstration de la pompe solaire ENNOS",
      fallback: "Impossible de charger la vidéo ? Ouvrir sur YouTube.",
    },
    success: {
      kicker: "Success Stories",
      title: "Des projets solaires concrets déployés avec Nexus Benin",
      stories: [
        {
          title: "Invest in Benin - Success Story #01",
          description:
            "Coordination d’un partenariat transfrontalier pour fournir des pompes solaires Ennos et systèmes d’irrigation à Solafrique à Ouagadougou.",
          tags: ["Investor", "Operator", "Beneficiary"],
        },
        {
          title: "Investir au Bénin - Success Story #02",
          description:
            "La Ferme de l’Espoir à Grand-Popo passe d’une moto-pompe au pompage solaire Ennos avec Nexus Benin.",
          tags: ["Client", "Solution", "Déploiement", "Impact"],
        },
        {
          title: "Accès à l’eau solaire – pilote GIZ",
          description:
            "Projet pilote avec 5 pompes solaires ENNOS déployées pour un accès à l’eau plus fiable et abordable.",
          tags: ["GIZ", "Accès à l’eau", "Pompes solaires"],
        },
      ],
    },
    invest: {
      kicker: "Investir au Bénin",
      title: "Investir dans l’eau, l’agriculture et l’énergie propre au Bénin",
      body:
        "Nexus Benin est un opérateur local et un partenaire de déploiement pour les investisseurs, programmes de développement, ONG, coopératives et entrepreneurs agricoles.",
      cta: "Parlons de votre projet",
      impactTitle: "Focus Impact",
      impactItems: [
        "Sécurité hydrique des exploitations",
        "Accès à l’énergie propre",
        "Rendements agricoles stables",
        "Partenariats public-privé",
      ],
      linkedinTitle: "Suivez-nous sur LinkedIn",
      linkedinBody:
        "Suivez nos projets, annonces et partenariats pour l’irrigation solaire au Bénin.",
      linkedinCta: "Voir Nexus Benin sur LinkedIn",
    },
    donation: {
      kicker: "Soutenir notre mission",
      title: "Supportez notre travail",
      body:
        "Vos contributions permettent à Nexus Benin d’accélérer l’accès à l’eau et aux solutions d’irrigation solaire durables.",
      buttons: {
        five: "Donner 5$",
        twenty: "Donner 20$",
        hundred: "Donner 100$",
      },
      note: "Don sécurisé. Merci pour votre soutien à Nexus Benin.",
      recommended: "Contribution recommandée",
    },
    donationProject: {
      title: "Eau propre, propulsée par le soleil",
      subtitle: "Un projet concret à Grand-Popo",
      body:
        "À seulement 200 mètres du siège de Nexus Benin à Grand-Popo, un village de pêcheurs vit encore sans eau courante.",
      highlights: [
        "Les familles vivant au bord de l’océan ont besoin d’eau sûre pour boire, cuisiner, se laver et assurer l’hygiène.",
        "Solution solaire : forage + pompe Ennos SLP 0,5 + module PV + réservoir d’eau.",
        "Budget total : 2 500 USD (tout inclus).",
      ],
      impact:
        "Ce système solaire fournira une eau potable fiable et améliorera l’hygiène quotidienne.",
      locationLabel: "Localisation du projet",
      mapLabel: "Voir sur Google Maps",
      ctaLine: "Aidez-nous à transformer le soleil en eau potable pour Grand-Popo.",
      imageAlt: "Village de pêcheurs à Grand-Popo",
    },
    donationTracker: {
      title: "Suivi d’impact",
      progressLabel: "Progression du financement",
      raisedLabel: "Déjà financé",
      remainingLabel: "Reste à financer",
      goalLabel: "Objectif",
    },
    donationFlow: {
      checkoutTitle: "Finaliser votre don",
      checkoutBody:
        "Votre contribution soutient directement les projets d’accès à l’eau et d’irrigation solaire au Bénin.",
      invalidAmount: "Montant non disponible. Veuillez choisir un don prédéfini.",
      initError: "Échec de l’initialisation du paiement. Veuillez réessayer.",
      captureError: "Échec de la confirmation du paiement. Merci de contacter notre équipe.",
      missingClientId: "Identifiant PayPal manquant. Merci de réessayer plus tard.",
      successTitle: "Merci pour votre don",
      successBody:
        "Votre soutien aide Nexus Benin à déployer des solutions solaires durables pour les communautés agricoles.",
      orderLabel: "ID de commande",
      cancelTitle: "Don annulé",
      cancelBody: "Votre don a été annulé. Vous pouvez réessayer à tout moment.",
      backHome: "Retour à l’accueil",
      retry: "Revenir aux dons",
    },
    faq: {
      kicker: "FAQ",
      title: "Questions fréquentes",
      items: [
        {
          question: "Pourquoi choisir une pompe solaire au Bénin ?",
          answer:
            "Le solaire réduit les coûts de carburant, sécurise l’accès à l’eau en saison sèche et limite la maintenance.",
        },
        {
          question: "Quelle capacité offrent les pompes ENNOS ?",
          answer:
            "Selon le modèle, les pompes ENNOS peuvent fournir jusqu’à plus de 200 000 litres par jour.",
        },
        {
          question: "Proposez-vous des kits clés en main ?",
          answer:
            "Oui, nous fournissons des kits complets avec pompe, panneaux PV, tuyaux et accessoires adaptés au terrain.",
        },
        {
          question: "Comment se déroule l’installation ?",
          answer:
            "Nos équipes locales assurent l’étude, l’installation et la formation des utilisateurs.",
        },
        {
          question: "À quoi servent les dons Grand-Popo ?",
          answer:
            "Les dons financent un système solaire complet pour fournir de l’eau potable au village de pêcheurs.",
        },
      ],
    },
    contact: {
      kicker: "Get in touch",
      title: "Déployez votre projet d’irrigation avec Nexus Benin.",
      whatsappLabel: "WhatsApp / Mobile",
      companyLabel: "Société",
      ifuLabel: "IFU",
      rccmLabel: "RCCM",
      addressTitle: "Adresse du principal établissement",
      addressTradeLabel: "Nom commercial",
      addressCountryLabel: "Pays",
      addressDepartmentLabel: "Département",
      addressCommuneLabel: "Commune",
      addressArrondissementLabel: "Arrondissement",
      addressQuartierLabel: "Quartier",
      mapKicker: "Localisation",
      mapTitle: "Nexus Benin à Grand-Popo",
      mapCta: "Ouvrir dans Google Maps",
      mapDirections: "Itinéraire",
      button: "Écrire sur WhatsApp",
      formSubject: "Demande de devis - Nexus Benin",
      formPlaceholders: {
        name: "Nom complet",
        phone: "Téléphone / WhatsApp",
        email: "Email",
        location: "Localisation du projet",
        landSize: "Surface (hectares)",
        waterSource: "Source d’eau",
        message: "Décrivez votre besoin",
      },
      formSubmit: "Envoyer ma demande",
      formSending: "Envoi en cours...",
      formSuccess: "Merci, votre message a bien été envoyé.",
      formError: "Impossible d’envoyer votre demande. Merci de réessayer.",
      formCaptchaRequired: "Veuillez valider le captcha pour envoyer votre demande.",
      formCaptchaError: "La vérification anti-spam a échoué. Merci de réessayer.",
      formCaptchaMissing: "Clé Turnstile manquante. Merci de réessayer plus tard.",
    },
    consent: {
      title: "Préférences de confidentialité",
      description:
        "Nous utilisons des cookies pour analyser le trafic et améliorer le site. Vous pouvez ajuster vos préférences.",
      privacyLinkLabel: "Politique de confidentialité",
      analytics: {
        label: "Statistiques",
        description: "Mesurer l’audience et les performances du site.",
      },
      marketing: {
        label: "Marketing",
        description: "Personnaliser les communications et campagnes.",
      },
      actions: {
        acceptAll: "Tout accepter",
        rejectAll: "Tout refuser",
        save: "Enregistrer mes choix",
      },
    },
    footer: {
      text: "Nexus Benin SAS — Solutions de pompage solaire et irrigation durable au Bénin.",
      privacy: "Politique de confidentialité",
      manageCookies: "Gérer mes cookies",
      linkedin: "LinkedIn",
      linkedinUrl: "https://www.linkedin.com/company/nexus-benin-sas",
    },
    privacyPolicy: {
      kicker: "Mentions légales",
      title: "Politique de confidentialité",
      intro:
        "Nous attachons une grande importance à la protection de vos données. Cette politique décrit la manière dont Nexus Benin SAS traite vos informations.",
      identity: {
        title: "Responsable du traitement",
        body:
          "Le responsable du traitement des données est Nexus Benin SAS. Pour toute question liée à la confidentialité, vous pouvez nous contacter.",
        company: "Entreprise : Nexus Benin SAS",
        contact: "Contact : sales@nexus-benin.com",
        host: "Hébergeur : Emergent",
      },
      data: {
        title: "Données collectées",
        body:
          "Nous collectons uniquement les données nécessaires au traitement de vos demandes et au suivi des dons.",
        items: [
          "Coordonnées (nom, email, téléphone)",
          "Informations de projet (localisation, surface, source d’eau)",
          "Messages envoyés via le formulaire",
          "Données techniques de navigation (cookies, statistiques anonymisées)",
        ],
      },
      usage: {
        title: "Utilisation des données",
        body: "Vos données sont utilisées pour :",
        items: [
          "Répondre à vos demandes et devis",
          "Suivre l’impact des dons",
          "Améliorer l’expérience utilisateur et les performances du site",
        ],
      },
      services: {
        title: "Prestataires et services tiers",
        body:
          "Nous utilisons des services tiers pour sécuriser, analyser et traiter les paiements :",
        items: [
          "PayPal (paiements et dons)",
          "Resend (envoi d’emails)",
          "Google Analytics (mesure d’audience)",
          "Cloudflare Turnstile (protection anti-spam)",
        ],
      },
      rights: {
        title: "Vos droits",
        body:
          "Vous disposez d’un droit d’accès, de rectification et de suppression de vos données. Vous pouvez également vous opposer à certains traitements.",
        items: [
          "Demander l’accès à vos données",
          "Demander la correction ou suppression",
          "Retirer votre consentement à tout moment",
        ],
      },
      cookies: {
        title: "Cookies et suivi",
        body:
          "Nous utilisons des cookies pour les statistiques et la sécurité. Vous pouvez gérer vos préférences via le bandeau de consentement.",
        items: [
          "Cookies statistiques (Google Analytics)",
          "Cookies techniques nécessaires au fonctionnement du site",
        ],
      },
      contact: {
        title: "Contact",
        body:
          "Pour toute question liée à la confidentialité, contactez-nous à sales@nexus-benin.com.",
      },
    },
    footer: {
      text: "Nexus Benin SAS — Solutions de pompage solaire et irrigation durable au Bénin.",
      privacy: "Politique de confidentialité",
      manageCookies: "Gérer mes cookies",
      linkedin: "LinkedIn",
      linkedinUrl: "https://www.linkedin.com/company/nexus-benin-sas",
    },
    privacyPolicy: {
      kicker: "Mentions légales",
      title: "Politique de confidentialité",
      intro:
        "Nous attachons une grande importance à la protection de vos données. Cette politique décrit la manière dont Nexus Benin SAS traite vos informations.",
      identity: {
        title: "Responsable du traitement",
        body:
          "Le responsable du traitement des données est Nexus Benin SAS. Pour toute question liée à la confidentialité, vous pouvez nous contacter.",
        company: "Entreprise : Nexus Benin SAS",
        contact: "Contact : sales@nexus-benin.com",
        host: "Hébergeur : Emergent",
      },
      data: {
        title: "Données collectées",
        body:
          "Nous collectons uniquement les données nécessaires au traitement de vos demandes et au suivi des dons.",
        items: [
          "Coordonnées (nom, email, téléphone)",
          "Informations de projet (localisation, surface, source d’eau)",
          "Messages envoyés via le formulaire",
          "Données techniques de navigation (cookies, statistiques anonymisées)",
        ],
      },
      usage: {
        title: "Utilisation des données",
        body: "Vos données sont utilisées pour :",
        items: [
          "Répondre à vos demandes et devis",
          "Suivre l’impact des dons",
          "Améliorer l’expérience utilisateur et les performances du site",
        ],
      },
      services: {
        title: "Prestataires et services tiers",
        body:
          "Nous utilisons des services tiers pour sécuriser, analyser et traiter les paiements :",
        items: [
          "PayPal (paiements et dons)",
          "Resend (envoi d’emails)",
          "Google Analytics (mesure d’audience)",
          "Cloudflare Turnstile (protection anti-spam)",
        ],
      },
      rights: {
        title: "Vos droits",
        body:
          "Vous disposez d’un droit d’accès, de rectification et de suppression de vos données. Vous pouvez également vous opposer à certains traitements.",
        items: [
          "Demander l’accès à vos données",
          "Demander la correction ou suppression",
          "Retirer votre consentement à tout moment",
        ],
      },
      cookies: {
        title: "Cookies et suivi",
        body:
          "Nous utilisons des cookies pour les statistiques et la sécurité. Vous pouvez gérer vos préférences via le bandeau de consentement.",
        items: [
          "Cookies statistiques (Google Analytics)",
          "Cookies techniques nécessaires au fonctionnement du site",
        ],
      },
      contact: {
        title: "Contact",
        body:
          "Pour toute question liée à la confidentialité, contactez-nous à sales@nexus-benin.com.",
      },
    },
  },
  en: {
    header: {
      nav: {
        solutions: "Solutions",
        highlights: "Benefits",
        resources: "Resources",
        success: "Success Stories",
        invest: "Invest in Benin",
        donate: "Donate",
        contact: "Contact",
      },
      whatsapp: "WhatsApp",
    },
    meta: {
      title: "Nexus Benin SAS | Solar pumps & irrigation in Benin",
      description:
        "Solar pumps, drip irrigation, water access and clean water projects in Benin. Official ENNOS Sunlight Pumps distributor.",
      ogTitle: "Nexus Benin SAS | Solar pumps & irrigation in Benin",
      ogDescription:
        "Solar pumps, drip irrigation, water access and clean water projects in Benin. Official ENNOS Sunlight Pumps distributor.",
      ogLocale: "en_US",
    },
    hero: {
      kicker: "Transforming access to water in Benin with solar energy",
      title: "Solar pumping & smart irrigation for Benin",
      subtitle:
        "Cut fuel costs, secure reliable water access, and grow your crops with ready-to-deploy solar solutions.",
      primaryCta: "Request a quote",
      secondaryCta: "View solutions",
      whatsappPrefill:
        "Hello Nexus Benin, I would like a quote for a solar irrigation project.",
      trustBadges: [
        "Ennos distributor in Benin",
        "Local installation",
        "Agriculture & water solutions",
        "Financing available",
      ],
      imageAlt: "Ennos SLP 0.5 HP solar pump",
    },
    problem: {
      kicker: "Problem / Opportunity",
      title: "Water is the first lever of agricultural productivity",
      body:
        "Across Benin, dry-season stress, fuel costs, and unreliable thermal pumping limit agricultural growth. Nexus Benin SAS delivers a clean, predictable, low‑maintenance solar alternative to secure year‑round water access.",
      impactTitle: "Immediate impact",
      impactItems: ["Lower fuel expenses", "Full energy autonomy", "Stronger farm productivity"],
      ctaPrimary: "Explore our solar solutions",
      ctaSecondary: "View the clean water project",
    },
    solutions: {
      kicker: "Solutions",
      title: "Solar solutions tailored to Benin’s agricultural realities",
      items: [
        {
          title: "Ennos solar pumps",
          description: "Fuel‑free pumping, mobile installation, direct solar operation.",
        },
        {
          title: "Drip irrigation",
          description: "Efficient water distribution for market gardens, agroforestry and farm projects.",
        },
        {
          title: "Turnkey agricultural kits",
          description: "Pump, PV panels, pipes, cables and accessories adapted to the field.",
        },
        {
          title: "Local deployment & support",
          description: "Advisory, importation, commissioning, training and follow‑up in Benin.",
        },
      ],
      cta: "Request a quote",
    },
    highlights: {
      kicker: "Product highlights",
      title: "Solid performance for irrigation and water access",
      items: [
        "Fuel‑free operation",
        "Easy & mobile installation",
        "Irrigation‑ready",
        "Lower operating costs",
        "Limited maintenance",
        "Long service life",
        "Up to 210,000 liters/day depending on model",
        "From small plots to 10+ hectares depending on design",
      ],
      note:
        "Performance depends on the model, total head, sunlight and site configuration.",
      button: "View Ennos 2025 catalog",
      imageAlt: "Drip irrigation kit",
    },
    resources: {
      kicker: "Resources",
      title: "Download our technical brochures",
      subtitle:
        "Datasheets, installation guides and ENNOS documentation to plan your project.",
      formatLabel: "PDF",
      items: [
        {
          id: "catalog-2025",
          title: "ENNOS 2025 Catalog",
          description: "Complete range of ENNOS solar pumps and accessories.",
          cta: "Download catalog",
        },
        {
          id: "datasheet-05hp",
          title: "Sunlight Pump 0.5 HP Datasheet",
          description:
            "Specs, flow rates and performance curves for the SLP 0.5 HP pump.",
          cta: "Download datasheet",
        },
        {
          id: "manual-2020",
          title: "Sunlight Pump Operational Manual 2020",
          description: "Operating steps, maintenance guidelines and safety notes.",
          cta: "Download manual",
        },
        {
          id: "install-guide-05hp",
          title: "Sunlight Pump 0.5 HP Installation Guide",
          description: "Field installation steps for fast commissioning.",
          cta: "Download guide",
        },
        {
          id: "dos-and-donts",
          title: "ENNOS Dos & Don'ts",
          description: "Best practices and safety recommendations for proper use.",
          cta: "Download guide",
        },
        {
          id: "app-guide",
          title: "ENNOS App Guide",
          description: "Setup and use of the ENNOS monitoring app.",
          cta: "Download guide",
        },
        {
          id: "ennos-brochure-fr",
          title: "ENNOS Brochure (FR)",
          description: "French brochure presenting ENNOS solutions and benefits.",
          cta: "Download brochure",
        },
        {
          id: "sunlight-pump-use-cases",
          title: "Sunlight Pump Use Cases",
          description: "Field application examples and outcomes.",
          cta: "Download use cases",
        },
        {
          id: "drip-kit-manual",
          title: "Drip Kit Manual",
          description: "Installation and usage guide for the drip irrigation kit.",
          cta: "Download manual",
        },
      ],
    },
    why: {
      kicker: "Why Nexus Benin",
      title: "A local partner turning solar into impact",
      partnerPoints: [
        "Local presence in Grand‑Popo, Benin",
        "Sourcing, import and deployment expertise",
        "Solutions adapted to farmers, NGOs, investors and institutions",
        "Responsive local support",
        "International partnerships and trusted solar technologies",
      ],
      roles: {
        hortense: "President, Nexus Benin SAS",
        martin: "Operations Director",
      },
      cardAlt: {
        hortense: "Nexus Benin business card",
        martin: "Martin Ehlers business card",
      },
    },
    ennosVideo: {
      kicker: "ENNOS on YouTube",
      title: "Discover ENNOS Sunlight Pumps in Action",
      subtitle: "Proven solar technology and real demonstrations",
      body:
        "Watch ENNOS pumps operate in real conditions. Nexus Benin provides local support for farms, NGOs and water access projects.",
      cta: "Watch ENNOS on YouTube",
      microcopy: "Official ENNOS demonstrations — backed by Nexus Benin support.",
      playLabel: "Play the video",
      thumbnailAlt: "ENNOS solar pump demonstration",
      fallback: "Video not loading? Open on YouTube.",
    },
    success: {
      kicker: "Success Stories",
      title: "Real solar projects delivered with Nexus Benin",
      stories: [
        {
          title: "Invest in Benin - Success Story #01",
          description:
            "Coordinated a cross‑border partnership to supply Ennos solar pumps and irrigation systems to Solafrique in Ouagadougou.",
          tags: ["Investor", "Operator", "Beneficiary"],
        },
        {
          title: "Invest in Benin - Success Story #02",
          description:
            "La Ferme de l’Espoir in Grand‑Popo switched from a moto‑pump to Ennos solar pumping with Nexus Benin.",
          tags: ["Client", "Solution", "Deployment", "Impact"],
        },
        {
          title: "Solar water access pilot – GIZ",
          description:
            "Pilot project with 5 ENNOS solar pumps delivering reliable and affordable water access.",
          tags: ["GIZ", "Water access", "Solar pumps"],
        },
      ],
    },
    invest: {
      kicker: "Invest in Benin",
      title: "Invest in water, agriculture and clean energy in Benin",
      body:
        "Nexus Benin is a local operator and deployment partner for investors, development programs, NGOs, cooperatives and agricultural entrepreneurs.",
      cta: "Let’s discuss your project",
      impactTitle: "Impact focus",
      impactItems: [
        "Farm water security",
        "Access to clean energy",
        "Stable agricultural yields",
        "Public‑private partnerships",
      ],
      linkedinTitle: "Follow us on LinkedIn",
      linkedinBody:
        "Stay updated on solar irrigation projects, partnerships, and impact in Benin.",
      linkedinCta: "Visit Nexus Benin on LinkedIn",
    },
    donation: {
      kicker: "Support our work",
      title: "Support our work",
      body:
        "Your donations help Nexus Benin expand reliable water access and solar irrigation solutions.",
      buttons: {
        five: "Donate $5",
        twenty: "Donate $20",
        hundred: "Donate $100",
      },
      note: "Secure donation. Thank you for supporting Nexus Benin.",
      recommended: "Recommended",
    },
    donationProject: {
      title: "Clean Water, Powered by the Sun",
      subtitle: "A concrete project in Grand-Popo",
      body:
        "Just 200 meters from the Nexus Benin headquarters in Grand-Popo, a fishing village still lives without running water.",
      highlights: [
        "Families by the ocean need safe water for drinking, cooking, washing, and hygiene.",
        "Solar solution: borehole + Ennos SLP 0.5 pump + PV module + water tank.",
        "Total budget: USD 2,500 (all included).",
      ],
      impact:
        "Powered by the sun, this system will deliver reliable drinking water and improve daily hygiene.",
      locationLabel: "Project location",
      mapLabel: "View on Google Maps",
      ctaLine: "Help us turn sunlight into clean water for Grand-Popo.",
      imageAlt: "Fishing village in Grand-Popo",
    },
    donationTracker: {
      title: "Impact tracker",
      progressLabel: "Funding progress",
      raisedLabel: "Raised",
      remainingLabel: "Remaining",
      goalLabel: "Goal",
    },
    donationFlow: {
      checkoutTitle: "Complete your donation",
      checkoutBody:
        "Your contribution directly supports clean water access and solar irrigation projects in Benin.",
      invalidAmount: "Amount not available. Please choose a preset donation.",
      initError: "Payment initialization failed. Please try again.",
      captureError: "Payment capture failed. Please contact our team.",
      missingClientId: "PayPal client ID is missing.",
      successTitle: "Thank you for your donation",
      successBody:
        "Your support helps Nexus Benin deliver sustainable solar solutions for farming communities.",
      orderLabel: "Order ID",
      cancelTitle: "Donation canceled",
      cancelBody: "Your donation was canceled. You can try again anytime.",
      backHome: "Back to home",
      retry: "Return to donations",
    },
    faq: {
      kicker: "FAQ",
      title: "Frequently asked questions",
      items: [
        {
          question: "Why choose a solar pump in Benin?",
          answer:
            "Solar pumping reduces fuel costs, secures dry‑season water access, and minimizes maintenance.",
        },
        {
          question: "What capacity do ENNOS pumps deliver?",
          answer:
            "Depending on the model, ENNOS pumps can deliver over 200,000 liters per day.",
        },
        {
          question: "Do you offer turnkey kits?",
          answer:
            "Yes, we provide complete kits with pump, PV panels, pipes, and field‑ready accessories.",
        },
        {
          question: "How does installation work?",
          answer:
            "Our local team handles the study, installation, and user training.",
        },
        {
          question: "What do Grand‑Popo donations fund?",
          answer:
            "Donations finance a full solar water system to provide safe drinking water.",
        },
      ],
    },
    contact: {
      kicker: "Get in touch",
      title: "Deploy your irrigation project with Nexus Benin.",
      whatsappLabel: "WhatsApp / Mobile",
      companyLabel: "Company",
      ifuLabel: "IFU",
      rccmLabel: "RCCM",
      addressTitle: "Main office address",
      addressTradeLabel: "Trade name",
      addressCountryLabel: "Country",
      addressDepartmentLabel: "Department",
      addressCommuneLabel: "Commune",
      addressArrondissementLabel: "District",
      addressQuartierLabel: "Neighborhood",
      mapKicker: "Location",
      mapTitle: "Nexus Benin in Grand-Popo",
      mapCta: "Open in Google Maps",
      mapDirections: "Directions",
      button: "Write on WhatsApp",
      formSubject: "Quote request - Nexus Benin",
      formPlaceholders: {
        name: "Full name",
        phone: "Phone / WhatsApp",
        email: "Email",
        location: "Project location",
        landSize: "Land size (hectares)",
        waterSource: "Water source",
        message: "Describe your needs",
      },
      formSubmit: "Send my request",
      formSending: "Sending...",
      formSuccess: "Thank you, your message has been sent.",
      formError: "We could not send your request. Please try again.",
      formCaptchaRequired: "Please complete the captcha before submitting.",
      formCaptchaError: "Anti-spam verification failed. Please try again.",
      formCaptchaMissing: "Turnstile key is missing. Please try again later.",
    },
    consent: {
      title: "Privacy preferences",
      description:
        "We use cookies to analyze traffic and improve the site. You can adjust your preferences.",
      privacyLinkLabel: "Privacy policy",
      analytics: {
        label: "Analytics",
        description: "Measure audience and site performance.",
      },
      marketing: {
        label: "Marketing",
        description: "Personalize communications and campaigns.",
      },
      actions: {
        acceptAll: "Accept all",
        rejectAll: "Reject all",
        save: "Save my choices",
      },
    },
    footer: {
      text: "Nexus Benin SAS — Solar pumping and sustainable irrigation solutions in Benin.",
      privacy: "Privacy policy",
      manageCookies: "Manage my cookies",
      linkedin: "LinkedIn",
      linkedinUrl: "https://www.linkedin.com/company/nexus-benin-sas",
    },
    privacyPolicy: {
      kicker: "Legal",
      title: "Privacy policy",
      intro:
        "We care about protecting your data. This policy explains how Nexus Benin SAS processes your information.",
      identity: {
        title: "Data controller",
        body:
          "The data controller is Nexus Benin SAS. For any privacy-related questions, you can contact us.",
        company: "Company: Nexus Benin SAS",
        contact: "Contact: sales@nexus-benin.com",
        host: "Hosting: Emergent",
      },
      data: {
        title: "Data collected",
        body:
          "We only collect the data required to handle your requests and donation tracking.",
        items: [
          "Contact details (name, email, phone)",
          "Project information (location, land size, water source)",
          "Messages sent via the form",
          "Technical navigation data (cookies, anonymized analytics)",
        ],
      },
      usage: {
        title: "How we use your data",
        body: "Your data is used to:",
        items: [
          "Respond to your requests and quotes",
          "Track donation impact",
          "Improve user experience and site performance",
        ],
      },
      services: {
        title: "Third-party services",
        body:
          "We use trusted third-party services to secure, analyze, and process payments:",
        items: [
          "PayPal (payments and donations)",
          "Resend (email delivery)",
          "Google Analytics (audience measurement)",
          "Cloudflare Turnstile (anti-spam protection)",
        ],
      },
      rights: {
        title: "Your rights",
        body:
          "You have the right to access, rectify, and delete your data, and to object to certain processing.",
        items: [
          "Request access to your data",
          "Request correction or deletion",
          "Withdraw consent at any time",
        ],
      },
      cookies: {
        title: "Cookies and tracking",
        body:
          "We use cookies for analytics and security. You can manage your preferences from the consent banner.",
        items: [
          "Analytics cookies (Google Analytics)",
          "Essential technical cookies for site operation",
        ],
      },
      contact: {
        title: "Contact",
        body:
          "For any privacy questions, contact us at sales@nexus-benin.com.",
      },
    },
  },
};